export default function submitPayment(PaymentAmount, Reference, purposeCode, setBankTransferResult, setScreen, setShowOverlay, chosenPayee, setError, isCard) {

  if (!window.OrendaGetResponse || window.isSiteBuilder) {
    setTimeout(() => {
      // setBankTransferResult({"status": "failure", "message": "We couldn't make your payment due to a lack of funds."})
      setBankTransferResult({"status": "success"});
      setScreen("Success");
      setShowOverlay(false);
    }, 1000);
    setShowOverlay(true);
    return;
  }

  // getResponse({ event_name: "makeBankTransfer", data: JSON.stringify({account, transfer_details, transfer_type}) }, response => {
  window.OrendaGetResponse(
    {
      event_name: "makeBankTransfer",
      data: JSON.stringify({
        payeeId: chosenPayee.id,
        PaymentAmount,
        Reference,
        purposeCode,
        isCard
      }),
    },
    (response) => {
      if (response.error) return setError(true);
      setBankTransferResult(response.bankTransfer); // "Your account is in default." // "We couldn't make your payment due to a lack of funds."
      setScreen("Success");
      setShowOverlay(false);
      return;
    }
  );
  setShowOverlay(true);
  return;
}